import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import * as actionCreators from '../../store/actions/login';
import { bindActionCreators } from 'redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { phoneNoMaskRegExpModified } from '../../utils/regexp';
import './PersonalInformation.scss';
import * as Yup from 'yup';
import Spinner from '../Spinner/Spinner';

import { Button } from 'react-bootstrap';
import Dialog from '../Dialogs/Dialog';
import { api } from '../../api/client';

const PersonalInformation = ({ profileUpdated, CurrentUser }) => {
    const [serverError, setServerError] = useState('');
    const [showDialog, setShowDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState({
        FirstName: '',
        LastName: '',
        PhoneNumber: '',
    });

    const personalInformationSchema = Yup.object().shape({
        FirstName: Yup.string().label('First Name').nullable().min(1).max(64).required(),
        LastName: Yup.string().label('Last Name').nullable().min(1).max(64).required(),
        PhoneNumber: Yup.string()
            .label('Phone Number')
            .nullable()
            .phone()
            .matches(phoneNoMaskRegExpModified, 'Invalid Phone Number.'),
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const userId = CurrentUser.userId;
                const response = await api.get('users', { params: { id: userId } });
                const responseData = response.data.Data;

                const updatedUser = {
                    FirstName: responseData.FirstName || '',
                    LastName: responseData.LastName || '',
                    PhoneNumber: responseData.PhoneNumber || '',
                };

                setUser(updatedUser);
                setLoading(false);
            } catch (error) {
                const errorMessage = error.message ? error.message : 'Something went wrong';
                setServerError(errorMessage);
                setLoading(false);
                console.log(error);
            }
        };

        fetchData();
    }, [CurrentUser]);

    const handleDialog = () => {
        setShowDialog(false);
    };

    const onSubmitHandler = (values, { setSubmitting }) => {
        setSubmitting(true);
        const userId = CurrentUser.userId;
        const userName = CurrentUser.unique_name;
        setLoading(true);

        api
            .put('users', {
                Id: userId,
                UserName: userName,
                FirstName: values.FirstName.trim(),
                LastName: values.LastName.trim(),
                PhoneNumber: values.PhoneNumber,
            })
            .then(function (response) {
                console.log(response);
                setSubmitting(false);

                if (response.data.Data) {
                    const userUpdated = response.data.Data;
                    const userPatch = {
                        unique_name: userUpdated.Email,
                        firstName: userUpdated.FirstName,
                        lastName: userUpdated.LastName,
                    };
                    console.log('User Profile has been updated, user info:', userPatch);
                    profileUpdated(userPatch);
                }

                setLoading(false);
                setShowDialog(true);
            })
            .catch(function (error) {
                setSubmitting(false);
                setLoading(false);
                const errorMessage = error.message ? error.message : 'Something went wrong';
                setServerError(errorMessage);
                console.log(error);
            });
    };

    return (
        <React.Fragment>
            <Formik
                enableReinitialize
                initialValues={user}
                validationSchema={personalInformationSchema}
                onSubmit={onSubmitHandler}
            >
                {({ isSubmitting, errors }) => (
                    <Form>
                        <div className="form-group">
                            <label htmlFor="FirstName">First Name</label>
                            <Field type="text" name="FirstName" restrict={/[a-zA-Z ]/} className="form-control" />
                            <ErrorMessage component="div" className="errorMessage" name="FirstName" />
                        </div>
                        <div className="form-group">
                            <label htmlFor="LastName">Last Name</label>
                            <Field type="text" name="LastName" restrict={/[a-zA-Z ]/} className="form-control" />
                            <ErrorMessage component="div" className="errorMessage" name="LastName" />
                        </div>
                        <div className="form-group">
                            <label htmlFor="PhoneNumber">Phone Number</label>
                            <Field type="text" name="PhoneNumber" className="form-control" />
                            <ErrorMessage component="div" className="errorMessage" name="PhoneNumber" />
                        </div>
                        {serverError && (
                            <div className="errorMessage" style={{ marginBottom: 10 }}>
                                {serverError}
                            </div>
                        )}
                        {loading && <Spinner />}
                        {showDialog && (
                            <Dialog
                                onClose={handleDialog}
                                title="Personal Info has been successfully updated."
                                show={showDialog}
                                closeButton={false}
                                closeButtonText="OK"
                            />
                        )}
                        <div className="button-group">
                            <Button
                                type="submit"
                                bsStyle="primary"
                                disabled={isSubmitting || Object.keys(errors).length > 0}
                            >
                                Update
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
            <br />
        </React.Fragment>
    );
};

export default connect(
    (state) => state.login,
    (dispatch) => bindActionCreators(actionCreators, dispatch)
)(PersonalInformation);
